var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServices(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.97,
    height: 16.776,
    viewBox: "0 0 20.97 16.776",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ticket-account",
    d: "M21.873,14.388a2.1,2.1,0,0,0,2.1,2.1v4.194a2.1,2.1,0,0,1-2.1,2.1H5.1a2.1,2.1,0,0,1-2.1-2.1V16.485a2.1,2.1,0,0,0,0-4.194V8.1A2.1,2.1,0,0,1,5.1,6H21.873a2.1,2.1,0,0,1,2.1,2.1v4.194a2.1,2.1,0,0,0-2.1,2.1M18.2,18.844c0-1.573-3.145-2.359-4.718-2.359s-4.718.786-4.718,2.359v.786H18.2v-.786M13.485,14.65a2.359,2.359,0,1,0-2.359-2.359,2.359,2.359,0,0,0,2.359,2.359Z",
    transform: "translate(-3 -6)",
    fill: "#6e7c8b"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/Services.2ae46af832e33e0e2d73421dd077434f.svg";
export { ForwardRef as ReactComponent };